require('slick-carousel');

export function initPlansSwitcher() {
  let $mode = "year";

  const $plans = document.querySelectorAll(".js-pricing-plan");
  const $plansToggler = document.querySelector(".js-pricing-plans-toggler");
  const $plansTogglerCircle = document.querySelector(
    ".js-pricing-plans-toggler-circle"
  );

  if (!$plansToggler) return;

  const togglePrices = function () {
    if ($mode === "month") {
      $plansTogglerCircle.dataset.mode = "year";
      $plans.forEach((el) => {
        el.dataset.mode = "year";
      });
      $mode = "year";
    } else if ($mode === "year") {
      $plansTogglerCircle.dataset.mode = "month";
      $plans.forEach((el) => {
        el.dataset.mode = "month";
      });
      $mode = "month";
    }
  };

  $plansToggler.addEventListener("click", () => {
    togglePrices();
  });
}

export function initPlansSlider() {
  const $plansList = $(".js-pricing-plans-list");
  const $plansItems = $(".js-pricing-plan");

  const itemWidth = 260;
  const gap = 16;
  const itemCount = $plansItems.length;

  const calculateSlidesToShow = (availableWidth) => {
    for (let slides = itemCount; slides >= 1; slides--) {
      const widthNeeded = itemWidth * slides + gap * (slides - 1);
      if (widthNeeded <= availableWidth) {
        return slides;
      }
    }
    return 1;
  };

  const checkAndInitSlider = () => {
    const viewportWidth = $(window).width();
    const containerPadding = 38;
    const availableWidth = viewportWidth - containerPadding;
    const $prevArrow = $(".js-pricing-plans-slider-arrow-prev");
    const $nextArrow = $(".js-pricing-plans-slider-arrow-next");
    const isSlickInitialized = $plansList.hasClass("slick-initialized");
    const totalWidthNeeded = itemWidth * itemCount + gap * (itemCount - 1);

    if (availableWidth < totalWidthNeeded) {
      const optimalSlidesToShow = calculateSlidesToShow(viewportWidth);

      if (!isSlickInitialized) {
        $plansList.slick({
          dots: false,
          infinite: false,
          speed: 300,
          slidesToShow: optimalSlidesToShow,
          slidesToScroll: 1,
          variableWidth: true,
          arrows: true,
          touchMove: true,
          draggable: true,
          prevArrow: $prevArrow,
          nextArrow: $nextArrow,
          responsive: [
            {
              breakpoint: 1440,
              settings: {
                slidesToShow: Math.min(4, itemCount),
                slidesToScroll: 1,
                variableWidth: true,
                arrows: true,
              },
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: Math.min(4, itemCount),
                slidesToScroll: 1,
                variableWidth: true,
                arrows: true,
              },
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: Math.min(3, itemCount),
                slidesToScroll: 1,
                variableWidth: true,
                arrows: true,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: true,
                arrows: false,
                centerMode: false,
                centerPadding: "0px",
              },
            },
          ],
        });
      }

      $prevArrow.css("display", "flex");
      $nextArrow.css("display", "flex");
    } else {
      if (isSlickInitialized) {
        $plansList.slick("unslick");
        $prevArrow.css("display", "none");
        $nextArrow.css("display", "none");
      }
    }
  };

  checkAndInitSlider();

  let resizeTimer;
  $(window).on("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      checkAndInitSlider();
    }, 250);
  });
}
